import React, { PropTypes } from 'react';

import Point from './Point';
import Rect from './Rect';

export default class PointAndRectList extends React.Component {

	getStyle() {
		const { points, rects } = this.props;

		let points2show = points.filter((p) => { if (!p.isCreating) return p; });
		let rects2show = rects.filter((r) => { if (!r.isCreating) return r; });
		
		if (points2show.length === 0 && rects2show.length === 0) {
			return {display: 'none'};
		}
	}

	render() {
		return (
			<div style={this.getStyle()}>
				<label>Lista de pontos e retângulos customizados</label>

				<div className='custom-point-list'>
					{this.props.points.map((point, i) =>
						point.isCreating ? null 
						: <div key={i} className='point'>
							<Point								
								point={point} 
								index={i}
								setLat={this.props.setLat} 
								setLng={this.props.setLng} 
								removePoint={this.props.removePoint} 
								addPointImage={this.props.addPointImage} 
								addPointImageWithSrc={this.props.addPointImageWithSrc} 
								removePointImage={this.props.removePointImage} 
								removeSavedPoint={this.props.removeSavedPoint} 
								removeSavedPointImage={this.props.removeSavedPointImage} 
								setPointSrc={this.props.setPointSrc} 
								setPointCaption={this.props.setPointCaption} 
								setPointLabel={this.props.setPointLabel} 
								setSavedPointCaption={this.props.setSavedPointCaption} 
								checkExistance={this.props.checkExistance} 
							/>
						</div>
					)}
					{this.props.rects.map((rect, i) =>
						rect.isCreating ? null 
						: <div key={i} className='point'>
							<Rect 								
								rect={rect} 
								index={i} 							
								removeRect={this.props.removeRect} 
								setLatNw={this.props.setLatNw} 
								setLngNw={this.props.setLngNw}
								setLatSe={this.props.setLatSe} 
								setLngSe={this.props.setLngSe}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

PointAndRectList.propTypes = {	
	points: PropTypes.array.isRequired,
	rects: PropTypes.array.isRequired,
	setLat: PropTypes.func.isRequired,
	setLng: PropTypes.func.isRequired,
	setPoints: PropTypes.func.isRequired,
	removePoint: PropTypes.func.isRequired,
	createPoint: PropTypes.func.isRequired,
	addPointImage: PropTypes.func.isRequired,
	addPointImageWithSrc: PropTypes.func.isRequired,
	removePointImage: PropTypes.func.isRequired,
	removeSavedPoint: PropTypes.func.isRequired,
	removeSavedPointImage: PropTypes.func.isRequired,
	setPointSrc: PropTypes.func.isRequired,
	setPointCaption: PropTypes.func.isRequired,
	setPointLabel: PropTypes.func.isRequired,
	setSavedPointCaption: PropTypes.func.isRequired,
	removeRect: PropTypes.func.isRequired,
	createRect: PropTypes.func.isRequired,
	setLatNw: PropTypes.func.isRequired,
	setLngNw: PropTypes.func.isRequired,
	setLatSe: PropTypes.func.isRequired,
	setLngSe: PropTypes.func.isRequired,
	custom: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	checkExistance: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/PointAndRectList.js